import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const MinMonthlyCollectionModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  minMonthlyCollectionAmount, onMinMonthlyCollectionAmountChange, minMonthlyCollectionAmountError, setMinMonthlyCollectionAmountError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Minimun monthly collection amount'
    buttonLabel='Set'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='minMonthlyCollectionAmount'
      value={minMonthlyCollectionAmount} onChange={onMinMonthlyCollectionAmountChange}
      error={minMonthlyCollectionAmountError} setError={setMinMonthlyCollectionAmountError}
    />
  </ModalFormUI>

export default MinMonthlyCollectionModalUI
